import Analytics from "./analytics";
import moment from "moment";
import { toMinutes } from "helpers/convertTime";
import {
  setClearFromActiveFilters,
  setClearFromDrawer,
  setClearedParams
} from "pages/licensing/mvp/state/params";

export const sendSortDropdownClick = (pagination) => {
  const analyticsPayload = {
    category: "LP_search_result_pages",
    total_search_result_pages: pagination?.totalPages,
    total_number_of_search_results: pagination?.totalResults
  };

  if (pagination?.currentPage >= 1 && pagination?.currentPage <= 3) {
    analyticsPayload.click_captured_on_page_number = pagination?.currentPage;
  }

  Analytics.track("Sort_by_dropdown_click", analyticsPayload);
};

export const sendSortDropdownOptionSelected = (pagination, sortingOption) => {
  const analyticsPayload = {
    category: "LP_search_result_pages",
    total_search_result_pages: pagination?.totalPages,
    total_number_of_search_results: pagination?.totalResults,
    sorting_option: sortingOption
  };

  if (pagination?.currentPage >= 3) {
    analyticsPayload.click_captured_on_page_number = pagination?.currentPage;
  }

  Analytics.track("Sorting_option_selected", analyticsPayload);
};

export const sendFilterOptionsSelected = (
  pagination,
  filterEventName,
  filterFieldName,
  filterCountFieldName,
  selectedValues
) => {
  const analyticsPayload = {
    category: "LP_search_result_pages",
    total_search_result_pages: pagination?.totalPages,
    total_number_of_search_results: pagination?.totalResults,
    [filterFieldName]: selectedValues,
    [filterCountFieldName]: pagination?.totalResults,
    click_captured_on_page_number: null
  };

  if (
    filterEventName.includes("Categories") &&
    pagination.currentPage >= 1 &&
    pagination.currentPage <= 3
  ) {
    analyticsPayload.click_captured_on_page_number = pagination?.currentPage;
  }

  if (!filterEventName.includes("Categories") && pagination.currentPage >= 3) {
    analyticsPayload.click_captured_on_page_number = pagination?.currentPage;
  }

  Analytics.track(filterEventName, analyticsPayload);
};

export const sendFilterAnalytics = (
  filterEventName,
  filterFieldName,
  filterCountFieldName,
  filterSelectedValues,
  pagination
) => {
  const selectedData = filterSelectedValues.filter((item) => item.checked);
  if (selectedData.length > 0) {
    const selectedValues = selectedData.map((item) => item.name).join(",");
    sendFilterOptionsSelected(
      pagination,
      filterEventName,
      filterFieldName,
      filterCountFieldName,
      selectedValues
    );
  }
};

export const sendClearAllFilterAnalytics = (pagination, params, dispatch) => {
  const { isClearFromDrawer, isClearFromActiveFilters, clearedParams } = params;
  if (isClearFromActiveFilters || isClearFromDrawer) {
    const postedFromLabel = clearedParams.postedFromLabel
      ? moment(clearedParams.postedFromLabel).format("DD:MM:YY")
      : null;
    const postedToLabel = clearedParams.postedToLabel
      ? moment(clearedParams.postedToLabel).format("DD:MM:YY")
      : null;

    const categories =
      clearedParams.activeCategories.length > 0
        ? clearedParams.activeCategories.map((item) => item.name).join(",")
        : false;
    const clearance =
      clearedParams.activeClearance.length > 0
        ? clearedParams.activeClearance.map((item) => item.name).join(",")
        : false;
    const footage =
      clearedParams.activeFootageType.length > 0
        ? clearedParams.activeFootageType.map((item) => item.name).join(",")
        : false;
    const orientation =
      clearedParams.activeOrientation.length > 0
        ? clearedParams.activeOrientation.map((item) => item.name).join(",")
        : false;
    const resolution =
      clearedParams.activeResolution.length > 0
        ? clearedParams.activeResolution.map((item) => item.name).join(",")
        : false;
    const tones =
      clearedParams.activeTones.length > 0
        ? clearedParams.activeTones.map((item) => item.name).join(",")
        : false;
    const uploaded =
      clearedParams.activeUploaded.length > 0
        ? clearedParams.activeUploaded.map((item) => item.name).join(",")
        : false;
    const duration = clearedParams.isDurationChange
      ? `${toMinutes(clearedParams.duration[0])} - ${toMinutes(clearedParams.duration[1])}`
      : false;
    const dates = clearedParams.arePostedDatesValid
      ? `${postedFromLabel} - ${postedToLabel}`
      : false;

    const activeFilters = `${categories ? `categories=${categories};` : ""}${
      duration ? `duration=${duration};` : ""
    }${dates ? `date_range=${dates};` : ""}${uploaded ? `uploaded_date=${uploaded};` : ""}${
      orientation ? `orientation=${orientation};` : ""
    }${footage ? `footage=${footage};` : ""}${clearance ? `use=${clearance};` : ""}${
      resolution ? `resolution=${resolution};` : ""
    }${tones ? `tones=${tones};` : ""}`;

    const eventName = isClearFromDrawer
      ? "Clear_All_Filter_section"
      : "Clear_All_Active_Filter_section";

    const analyticsPayload = {
      category: "LP_search_result_pages",
      total_search_result_pages: pagination?.totalPages,
      total_number_of_search_results: pagination?.totalResults,
      active_filters: activeFilters
    };

    console.log("search test", activeFilters);

    Analytics.track(eventName, analyticsPayload);

    dispatch(setClearFromActiveFilters(false));
    dispatch(setClearFromDrawer(false));
    dispatch(setClearedParams(null));
  }
};

export const sendFiltersAnalytics = (pagination, params) => {
  const {
    categories,
    tones,
    clearance,
    footageType,
    orientation,
    uploaded,
    dates,
    duration,
    resolution,
    countries,
    smartCountries,
    similarClip,
    previousSearchTerm
  } = params;

  sendFilterAnalytics(
    "Filter_Categories",
    "selected_category",
    "number_of_search_result_for_selected_category",
    categories,
    pagination
  );
  sendFilterAnalytics(
    "Filter_Tones",
    "selected_tone",
    "number_of_search_result_for_selected_tone",
    tones,
    pagination
  );
  sendFilterAnalytics(
    "Filter_Resolution",
    "selected_resolution",
    "number_of_search_result_for_selected_resolution",
    resolution,
    pagination
  );
  sendFilterAnalytics(
    "Filter_Footage_Type",
    "selected_footage_type",
    "number_of_search_result_for_selected_footage_type",
    footageType,
    pagination
  );
  sendFilterAnalytics(
    "Filter_Orientation",
    "selected_orientation",
    "number_of_search_result_for_selected_orientation",
    orientation,
    pagination
  );
  sendFilterAnalytics(
    "Filter_Uploaded_date",
    "selected_uploaded_date",
    "number_of_search_result_for_selected_uploaded_date",
    uploaded,
    pagination
  );
  sendFilterAnalytics(
    "Filter_Use",
    "selected_use",
    "number_of_search_result_for_selected_use",
    clearance,
    pagination
  );
  sendFilterAnalytics(
    "Filter_Location",
    "selected_country",
    "number_of_search_result_for_selected_country",
    countries,
    pagination
  );
  sendFilterAnalytics(
    "Location_smart_filter",
    "Selected_Location_smart_filter",
    "number_of_search_result_for_selected_country",
    smartCountries,
    pagination
  );

  if (similarClip !== null) {
    Analytics.track("View_Similar_clips", {
      Similar_to_JMID: similarClip.jmId,
      no_of_similar_clips: pagination.totalResults,
      search_term: previousSearchTerm,
      search_type: previousSearchTerm === "" ? "null_search" : "keyword_search"
    });
  }

  const { postedFrom, postedTo } = dates;
  const today = moment().endOf("day");
  const isFutureFromDate = moment(postedFrom).isAfter(today);
  const isFutureToDate = moment(postedTo).isAfter(today);

  const postedFromLabel = postedFrom ? moment(postedFrom).format("DD:MM:YY") : null;
  const postedToLabel = postedTo ? moment(postedTo).format("DD:MM:YY") : null;
  const isFromDateAfterToDate = moment(postedFrom).isAfter(postedTo);

  const arePostedDatesValid =
    postedFromLabel !== null &&
    postedToLabel !== null &&
    !isFutureFromDate &&
    !isFutureToDate &&
    !isFromDateAfterToDate &&
    postedFrom.isValid() &&
    postedTo.isValid();

  if (arePostedDatesValid) {
    sendFilterOptionsSelected(
      pagination,
      "Filter_Date_range",
      "selected_date_range",
      "number_of_search_result_for_selected_date_range",
      `${postedFromLabel} - ${postedToLabel}`
    );
  }

  const isDurationChange = duration[0] !== 0 || duration[1] !== 600;

  if (isDurationChange) {
    sendFilterOptionsSelected(
      pagination,
      "Filter_Duration",
      "selected_duration_range",
      "number_of_search_result_for_selected_duration_range",
      `${toMinutes(duration[0])} - ${toMinutes(duration[1])}`
    );
  }
};
